import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { ContactProjectsListDataTableProjectWorkerEmployeesFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

interface WorkersProps {
  employees: ContactProjectsListDataTableProjectWorkerEmployeesFragment[]
  totalCount: number
}

const ProjectWorkers = ({ employees, totalCount }: WorkersProps) => {
  const remaining = totalCount - employees.length

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      {employees.map(
        (employee) =>
          employee && (
            <Avatar
              size="s24"
              url={buildUrl(employee.access.avatar)}
              label={employee.fullName}
              key={employee.access.id}
            />
          )
      )}
      {remaining !== 0 && <Text size="200">{`+${remaining}`}</Text>}
    </Box>
  )
}

export default ProjectWorkers
